<template>
  <card-dialog
    v-model="modalVisible"
    max-width="800px"
    :title="$t('card_title.add_exercises_timing')"
  >
    <template v-slot:title>
      <v-card-title
        class="blue-grey lighten-5 px-6 py-4"
      >
        <div>
          <div>
            {{ $t('card_title.add_exercises_timing') }}
          </div>
          <div
            v-if="player"
            class="text-body-1 mt-1"
          >
            {{ player.first_name }} {{ player.last_name }}
          </div>
        </div>
      </v-card-title>
    </template>

    <v-card-text
      class="pa-6"
    >
      <validation-observer ref="validation">
        <div
          v-for="exercise in exercisesDirty"
          :key="exercise.id"
          class="mb-1"
        >
          <v-card
            v-if="exercise.type === 'group'"
            rounded="lg"
            class="px-3 py-2"
            outlined
          >
            <div class="mb-2">
              {{ exercise.params.title || 'Section' }}
            </div>
            <div
              v-for="subExercise in exercise.exercises"
              :key="'sub'+subExercise.id"
            >
              <exercise-period-entry-row
                :exercise.sync="subExercise"
                :event="event"
              />
            </div>
          </v-card>
          <div
            v-if="exercise.type === 'exercise' || exercise.type === 'pause' || exercise.type === 'superset'"
          >
            <exercise-period-entry-row
              :exercise.sync="exercise"
              :event="event"
            />
          </div>
        </div>
      </validation-observer>
    </v-card-text>

    <template v-slot:actions>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="grey"
          text
          @click="modalVisible = false"
        >
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          large
          @click="submit()"
        >
          {{ $t("button.save") }}
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import { cloneDeep } from 'lodash'
import ExercisePeriodEntryRow from '@/components/training-builder/ExercisePeriodEntryRow.vue'

export default {
  name: 'ExercisesPeriodsDialog',
  components: { ExercisePeriodEntryRow, CardDialog },
  mixins: [deleteConfirmationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    trainingExercises: {
      type: Array,
      required: true
    },
    player: {
      type: Object,
      default: () => null
    },
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      exercisesDirty: []
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  watch: {
    visible: function (value) {
      if (!value) return

      this.transformExercises()
    }
  },
  methods: {
    transformExercises() {
      const exercises = cloneDeep(this.trainingExercises)

      this.exercisesDirty = exercises.map(e => {
        return this.transformExercise(e)
      })
    },
    transformExercise(e) {
      if ('exercises' in e && ['superset', 'group'].indexOf(e.type) > -1) {
        if (e.type === 'superset') {
          e.exercise_start_at = e.exercises[0].exercise_start_at ? this.$dayjs(e.exercises[0].exercise_start_at).format('HH:mm:ss') : undefined
          e.exercise_stop_at = e.exercises[0].exercise_stop_at ? this.$dayjs(e.exercises[0].exercise_stop_at).format('HH:mm:ss') : undefined
        }

        e.exercises = e.exercises.map(ex => {
          return this.transformExercise(ex)
        })

        return e
      }

      if (e.type === 'pause' || e.type === 'exercise') {
        e.exercise_start_at = e.exercise_start_at ? this.$dayjs(e.exercise_start_at).format('HH:mm:ss') : undefined
        e.exercise_stop_at = e.exercise_stop_at ? this.$dayjs(e.exercise_stop_at).format('HH:mm:ss') : undefined
      }

      return e
    },
    propagateSupersetTimings(e) {
      if (e.type === 'superset') {
        e.exercises.map(ex => {
          ex.exercise_start_at = e.exercise_start_at
          ex.exercise_stop_at = e.exercise_stop_at
          return ex
        })
      } else if (e.type === 'group') {
        e.exercises.map(ex => {
          return this.propagateSupersetTimings(ex)
        })
      }
      return e
    },
    formatTimings(e) {
      if (e.exercise_start_at) {
        const [hours, minutes, seconds] = e.exercise_start_at.split(':').map(Number)
        e.exercise_start_at = this.$dayjs().hour(hours).minute(minutes).second(seconds).utc().toISOString()
      }
      if (e.exercise_stop_at) {
        const [hours, minutes, seconds] = e.exercise_stop_at.split(':').map(Number)
        e.exercise_stop_at = this.$dayjs().hour(hours).minute(minutes).second(seconds).utc().toISOString()
      }
    },
    preprocessExercisesTimings(e) {
      if ('exercises' in e && ['superset', 'group'].indexOf(e.type) > -1) {
        if (e.type === 'superset') {
          this.formatTimings(e)
        }

        e.exercises = e.exercises.map(ex => {
          return this.preprocessExercisesTimings(ex)
        })

        return e
      }

      if (e.type === 'pause' || e.type === 'exercise') {
        this.formatTimings(e)
      }
      return e
    },
    async submit() {
      this.exercisesDirty.map(e => {
        return this.propagateSupersetTimings(e)
      })

      this.exercisesDirty.map(e => {
        return this.preprocessExercisesTimings(e)
      })

      this.$emit('update:edit-items', this.exercisesDirty)

      this.modalVisible = false
    }
  }
}
</script>
